import { gql } from '@apollo/client'
import { SABRE_PACKAGING_FRAGMENT } from './PackagingFragment'
import { SABRE_SHIPPING_FRAGMENT } from './ShippingFragment'
import { CATEGORY_FRAGMENT } from './CategoryFragment'
import { IMAGE_FRAGMENT } from './ImageFragment'
import { PLANOGRAM_IMAGES_FRAGMENT } from './PlanogramImageFragment'
import { SABRE_FLAVOR_FRAGMENT } from './FlavorFragment'
import { SABRE_MANUFACTURER_FRAGMENT } from './ManufacturerFragment'

export const SABRE_PRODUCT_FRAGMENT = gql`
  fragment Product on Product {
    id
    created
    modified
    upcA
    upcE
    name
    preferredName
    packagingName
    source
    fullName
    commonName {
      id
      name
    }
    brand {
      id
      name
    }
    manufacturer {
      ...Manufacturer
    }
    drafts {
      id
      name
      createdBy
      dateResolved
      fieldsAccepted
      notes
      needsUpdatedImage
      shipping {
        ...Shipping
      }
      category {
        ...Category
      }
      brand {
        id
        name
      }
      packaging {
        ...Packaging
      }
      manufacturer {
        ...Manufacturer
      }
      flavors {
        ...Flavor
      }
    }
    flavors {
      ...Flavor
    }
    marketingImageUrl
    planogramImages {
      ...PlanogramImages
    }
    images {
      ...Image
    }
    category {
      ...Category
    }
    packaging {
      ...Packaging
    }
    shipping {
      ...Shipping
    }
    verifiedBy
  }
  ${PLANOGRAM_IMAGES_FRAGMENT}
  ${SABRE_FLAVOR_FRAGMENT}
  ${IMAGE_FRAGMENT}
  ${CATEGORY_FRAGMENT}
  ${SABRE_PACKAGING_FRAGMENT}
  ${SABRE_SHIPPING_FRAGMENT}
  ${SABRE_MANUFACTURER_FRAGMENT}
`
